module.exports = __webpack_public_path__ + "menu.png?bb83fd3470002305dda1a484c0b81e69";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu.png
// module id = 684
// module chunks = 0 2 7 8 9 10